import React, { useEffect, useState } from "react";
import DynamicCRUD from "../common/DynaminCrud";
import { getBranchConfig } from "./brancheConfig";
import PermissionDenied from "../../utils/permission_denied";
import { AuthHelper } from "../../utils/authHelper";
import AuthApi from "../../api/authApi";

const Branch = ({ permissions, ...props }) => {

  const isSuperAdmin = AuthHelper.isSuperAdmin?.();
  const currentUser = AuthHelper.getUser?.();
  const [canCreateBranch, setCanCreateBranch] = useState(
    Boolean(currentUser?.can_create_branch)
  );

  useEffect(() => {
    let isMounted = true;

    const loadBranchCreateFlag = async () => {
      const result = await AuthApi.getPermissions();
      if (!isMounted || !result?.success) return;

      setCanCreateBranch(Boolean(result.can_create_branch));
    };

    loadBranchCreateFlag();

    return () => {
      isMounted = false;
    };
  }, []);

  const mergedPermissions = {
    ...permissions,
    allowCreate: Boolean(permissions?.allowCreate && canCreateBranch),
  };

  console.log("Branch Component Permissions:", permissions?.allow);

  if (!isSuperAdmin && !permissions?.allowView) {
    return <PermissionDenied />;
  }

  const finalConfig = getBranchConfig({
    canCreate: mergedPermissions.allowCreate,
    canEdit: mergedPermissions.allowEdit,
    canDelete: mergedPermissions.allowDelete
  });
  console.log("finalConfigfinalConfig", finalConfig);

  return (
    <DynamicCRUD
      {...finalConfig}
      icon="fa-solid fa-building"
      permissions={mergedPermissions}
    />
  );
};

export default Branch;
